<mat-toolbar>
  <button mat-icon-button matTooltip="Volver al dashboard" routerLink="/contenedores">
    <mat-icon color="primary">arrow_back</mat-icon>
  </button>
  Contenedores
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)="newContenedor()"><mat-icon color="primary">add_circle_outline</mat-icon> Añadir contenedor</button>
    <button mat-menu-item routerLink="/contenedores-tipos"><mat-icon color="primary">format_list_numbered</mat-icon> Gestionar tipos</button>
    <button mat-menu-item (click)="saveExcel()"><mat-icon color="primary">description</mat-icon> Exportar tabla</button>
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class="tableHeader">
    <mat-form-field  class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
    </mat-form-field>
    <mat-form-field class="filterInputs searchMobile">
      <mat-label>Estado</mat-label>
      <mat-select [(ngModel)]="estado" (selectionChange)="getContenedores()" >
        <mat-option value="all">Todos</mat-option>
        <mat-option value="stock">En Stock</mat-option>
        <mat-option value="cliente">En Cliente</mat-option>
        <mat-option value="maintenance">Mantenimiento</mat-option>
        <mat-option value="incidence">Incidencia</mat-option>
        <mat-option value="baja">Baja</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div #TABLE class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef > </th>
        <td mat-cell *matCellDef="let element" class='miniCell'>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon matTooltip="Acciones">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editarContenedor(element.id)">
              <mat-icon color="primary">create</mat-icon>
              <span>Ver/Modificar</span>
            </button>
            <button mat-menu-item (click)="deleteContenedor(element.id)">
              <mat-icon color="primary">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Matricula </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.matricula}} </td>
      </ng-container>
      <ng-container matColumnDef="matricula_old">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Mat. antigua</th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.matricula_old}} </td>
      </ng-container>
      <ng-container matColumnDef="medidas">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Medidas </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.medidas}} </td>
      </ng-container>
      <ng-container matColumnDef="tipo_nombre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Tipo </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.tipo_nombre}} </td>
      </ng-container>
      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Estado </th>
        <td mat-cell *matCellDef="let element" class='minWidth'>
          @if (element.estado === 'stock') {
            <mat-icon class='green' matTooltip="En Stock">home</mat-icon>
          }
          @if (element.estado === 'cliente') {
            <mat-icon class='orange' matTooltip="En Cliente">person_pin_circle</mat-icon>
          }
          @if (element.estado === 'maintenance') {
            <mat-icon class='grey' matTooltip="Mantenimiento">build</mat-icon>
          }
          @if (element.estado === 'incidence') {
            <mat-icon class='red' matTooltip="Incidencia">report_problem</mat-icon>
          }
          @if (element.estado === 'baja') {
            <mat-icon class='red' matTooltip="Baja">fiber_manual_record</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Cliente </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.cliente}} </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="5">No existen contenedores...<br> <button mat-stroked-button (click)="newContenedor()">Crear contenedor</button></td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
</div>
